import { render, staticRenderFns } from "./addNewOrderPerson.vue?vue&type=template&id=07dfb9d7"
import script from "./addNewOrderPerson.vue?vue&type=script&lang=js"
export * from "./addNewOrderPerson.vue?vue&type=script&lang=js"
import style0 from "./addNewOrderPerson.vue?vue&type=style&index=0&id=07dfb9d7&prod&lang=scss&scope=true"
import style1 from "./addNewOrderPerson.vue?vue&type=style&index=1&id=07dfb9d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports